import * as yup from 'yup'

const schema = yup.object().shape({
  justification: yup
    .string()
    .trim()
    .required('Preencha a justificativa para continuar.'),
})

export default schema
